import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getCurrentUser } from '../../services/authService';

/* Экран для зарегистрированного ученика, которого ещё не добавили на курс.
   Каждые 15 секунд проверяем — не зачислили ли; как только курс появился,
   обновляем пользователя в контексте и кабинет открывается сам. */
const WaitingPage = () => {
  const { user, logout, updateUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let stop = false;
    const check = async () => {
      try {
        const res = await getCurrentUser();
        if (!stop && res?.user?.course) updateUser({ course: res.user.course });
      } catch { /* игнорируем сетевые сбои */ }
    };
    const id = setInterval(check, 15000);
    return () => { stop = true; clearInterval(id); };
  }, [updateUser]);

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 24, boxSizing: 'border-box'
    }}>
      <style>{`
        .wait-brand { font-family: var(--font-display); font-size: 34px; letter-spacing: 1.6px;
          line-height: 1.05; text-transform: uppercase; color: var(--text-1); margin-bottom: 24px; }
        .wait-ic { width: 64px; height: 64px; border-radius: 50%; margin: 0 auto 18px;
          background: var(--primary-light); color: var(--text-1);
          display: flex; align-items: center; justify-content: center; }
        body.dark .wait-brand, body.dark .wait-ic { color: #fff; }
      `}</style>
      <div style={{
        maxWidth: 440, width: '100%', textAlign: 'center', background: 'var(--card)',
        border: '1px solid var(--border)', borderRadius: 20, padding: '36px 28px',
        boxShadow: '0 20px 50px rgba(40,20,80,0.12)'
      }}>
        {/* Название и часы — цветом текста: фиолетовый на тёмном фоне читался хуже */}
        <div className="wait-brand">ИНФА СОТКА</div>
        <div className="wait-ic">
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" />
          </svg>
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-1)', margin: '0 0 12px' }}>
          Спасибо за регистрацию!
        </h1>
        <p style={{ fontSize: 14.5, color: 'var(--text-2)', lineHeight: 1.6, margin: '0 0 8px' }}>
          Ваш аккаунт создан. Сейчас преподаватель добавит вас на курс — после этого
          доступ откроется автоматически, и вам придёт уведомление на почту.
        </p>
        <p style={{ fontSize: 13, color: 'var(--text-3)', margin: '0 0 24px' }}>
          {user?.email}
        </p>
        <button
          onClick={handleLogout}
          style={{
            background: 'transparent', border: '1px solid var(--border)', borderRadius: 11,
            padding: '10px 20px', color: 'var(--text-2)', cursor: 'pointer',
            fontSize: 13, fontWeight: 600, fontFamily: 'inherit'
          }}
        >
          Выйти
        </button>
      </div>
    </div>
  );
};

export default WaitingPage;
